
import { mapState } from 'vuex';

export default {
  name: 'LandingPageProductRecommendationsSection',
  computed: {
    ...mapState('crmLandingPage', ['productRecommendations'])
  }
};
